import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import eEventTypes from '../../enums/eEventTypes';
import ControllerWinCombination from './ControllerWinCombination';
import eSymbolIndex from '../../symbols/eSymbolIndex';
import ControllerBringSymbolsToFront from './ControllerBringSymbolsToFront';

export default class ControllerFeatures {
  constructor({ topContainer,reelsContainer, controllerReels }) {
    this.topContainer = topContainer;
    this.reelsContainer = reelsContainer;
    this.ControllerReels = controllerReels;

    this._bringToFrontTriggerIds = [];

    this.init();
  }

  init() {
    this.ControllerBringToFrontSymbols = new ControllerBringSymbolsToFront(this.topContainer);
    this.ControllerWinCombination = new ControllerWinCombination({
      controllerReels: this.ControllerReels,
      reelsContainer: this.reelsContainer,
      topContainer: this.topContainer,
    });
  }

  onCycleDataSymbol(...args) {
  }

  onCycleAvailableSymbol(...args) {
  }

  startWinnings(data) {
    this.ControllerWinCombination.startWinnings(data);
  }

  showWin(data) {
    this.ControllerWinCombination.showCombination(data);
  }

  reset() {
    this.ControllerWinCombination.end();
    this.ControllerBringToFrontSymbols.bringAllBack();
  }

  showBonusGameStart(symbols) {
    this.ControllerWinCombination.showBonusGameStart(symbols);
  };

  onReelHitBar(reelIndex) {
    const symbols = this.ControllerReels.reels[reelIndex].symbols[this.ControllerReels.topSimbolsCount].symbols;
    for (let i = 0; i <= symbols.length - 1; i++) {
      const symbol = symbols[i];
      if (this._bringToFrontTriggerIds.includes(symbol.id)) {
        this.ControllerBringToFrontSymbols.bringToFront(symbol);
      }
    }
  }
}
